import { CdrAccordion as A, CdrText as T, CdrAccordionGroup as C } from "@rei/cedar";
import { resolveComponent as a, openBlock as c, createBlock as g, withCtx as d, createTextVNode as m, toDisplayString as p, createElementVNode as q, createCommentVNode as y, createElementBlock as u, normalizeClass as _, createVNode as f, Fragment as w, renderList as b } from "vue";
const x = (n, t) => {
  const e = n.__vccOpts || n;
  for (const [i, r] of t)
    e[i] = r;
  return e;
}, Q = {
  /* c8 ignore start */
  name: "QuestionAnswerPair",
  components: {
    CdrAccordion: A
  },
  props: {
    entry: {
      type: Object,
      default() {
        return null;
      }
    },
    faqGroupId: {
      type: String,
      required: !0
    },
    index: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      opened: !1
    };
  },
  methods: {
    handleToggle(n) {
      const {
        opened: t
      } = this, e = t ? "close" : "open";
      this.opened = !t, this.$emit("toggle", {
        action: e,
        index: n
      });
    }
  }
  /* c8 ignore end */
}, G = ["innerHTML"];
function N(n, t, e, i, r, o) {
  const s = a("cdr-accordion");
  return e.entry ? (c(), g(s, {
    key: 0,
    id: `${e.faqGroupId}-${e.index}`,
    opened: r.opened,
    "data-location-name": e.index + 1,
    level: "3",
    "data-ui": "faq-entry",
    onAccordionToggle: t[0] || (t[0] = () => o.handleToggle(e.index))
  }, {
    label: d(() => [m(p(e.entry.question), 1)]),
    default: d(() => [q("div", {
      class: "faq-entry__answer",
      innerHTML: e.entry.answer
    }, null, 8, G)]),
    _: 1
  }, 8, ["id", "opened", "data-location-name"])) : y("", !0);
}
const F = /* @__PURE__ */ x(Q, [["render", N]]);
const I = {
  name: "FAQ",
  components: {
    CdrText: T,
    CdrAccordionGroup: C,
    QuestionAnswerPair: F
  },
  props: {
    faq: {
      type: Object,
      default() {
        return null;
      }
    },
    faqGroupId: {
      type: String,
      default: "faq"
    },
    backgroundColor: {
      type: String,
      default: "primary"
    }
  },
  computed: {
    entries() {
      const {
        questionsAndAnswers: n
      } = this.faq || {};
      return n || null;
    }
  },
  methods: {
    handleToggle(n) {
      this.$emit("toggle", n);
    }
  }
};
function S(n, t, e, i, r, o) {
  const s = a("cdr-text"), h = a("question-answer-pair"), k = a("cdr-accordion-group");
  return o.entries ? (c(), u("div", {
    key: 0,
    class: _(["faq-container", `faq-container--${e.backgroundColor}`]),
    "data-ui": "frequently-asked-questions"
  }, [q("div", {
    class: _(["faq-container__content", `faq-container__content--${e.backgroundColor}`])
  }, [f(s, {
    tag: "h2",
    class: "heading"
  }, {
    default: d(() => [m(p(e.faq.title), 1)]),
    _: 1
  }), f(k, null, {
    default: d(() => [(c(!0), u(w, null, b(o.entries, (l, v) => (c(), g(h, {
      key: `${l.question}`,
      entry: l,
      index: v,
      "faq-group-id": e.faqGroupId,
      onToggle: o.handleToggle
    }, null, 8, ["entry", "index", "faq-group-id", "onToggle"]))), 128))]),
    _: 1
  })], 2)], 2)) : y("", !0);
}
const L = /* @__PURE__ */ x(I, [["render", S]]);
export {
  L as default
};
